/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const divorceCostsStyle = {
  divorceCosts: {
    textAlign: "left",
  },
  money: {
    /*fontWeight: "bold",*/
    textAlign: "right",
    marginBottom: "1.5rem",
  },
  sum: {
    color: "primary.main",
  },
  postfix: {
    textAlign: "center",
    marginBottom: "1.5rem",
  },
  divider: {
    margin: "-.75rem 0",
    backgroundColor: "#000000",
  },
  hintBox: {
    margin: "0 auto",
    maxWidth: 500,
    textAlign: "center",
    border: "1px solid " + "primary.main",
    borderRadius: "5px",
    padding: { xs: "1rem 0.2rem 0 0.2rem", sm: "1rem 3rem 0 3rem" },
  },
};

export default divorceCostsStyle;
